import { AnimatePresence, motion } from 'motion/react';
import { FC, useEffect, useState } from 'react';

export type TProps = {
  src: string;
  thumbnailSrc?: string;
  alt?: string;
};

const LightBoxImage: FC<TProps> = (props) => {
  const { src, thumbnailSrc, alt } = props;

  const [isLoadingSrc, setIsLoadingSrc] = useState(false);

  useEffect(() => {
    setIsLoadingSrc(true);
  }, [src]);

  return (
    <>
      <img
        // oxlint-disable-next-line payaca/no-tailwind-arbitrary-values -- Viewport-relative size
        className="w-full max-h-[calc((100svh-(var(--spacing-4)*2)-7rem))] h-auto"
        src={src}
        alt={alt}
        onLoad={() => {
          setIsLoadingSrc(false);
        }}
      />

      <AnimatePresence>
        {isLoadingSrc && (
          <motion.div
            className="absolute inset-0 w-full h-full"
            animate={{
              opacity: 1,
            }}
            exit={{
              opacity: 0,
            }}
            style={{
              backgroundImage: `url(${thumbnailSrc})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            <motion.div
              className="absolute inset-0"
              animate={{
                backdropFilter: ['blur(44px)', 'blur(64px)', 'blur(44px)'],
              }}
              transition={{
                ease: 'easeInOut',
                repeat: Infinity,
                duration: 2,
              }}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default LightBoxImage;
